<div class="iconsWrapper">
  <div *ngFor="let icon of googleIconsService.google_icons" (click)="selectedIcon(icon)">
    <mat-icon class="material-icons-outlined">{{ icon }}</mat-icon>
    {{ icon }}
  </div>
</div>
